/**
 * Take a range, 0 -> rangeMax, divide it into a certain number of sections
 * and determine in which section does a value sit.
 *
 * sections are indexed at 0 when returned, i.e. passing sections = 10
 * will return values in range 0 -> 9
 */
export const getDiscreteValueFromRange = (
  value: number,
  sections = 10,
  rangeMax = 100,
): number => {
  const sectionSize = rangeMax / sections;
  const sectionForValue = Math.floor(value / sectionSize);
  const maxSection = sections - 1;
  const minSection = 0;

  return Math.min(Math.max(sectionForValue, minSection), maxSection);
};
